import { registerAuthTeardown } from '@/utils/auth-teardown';

const STORAGE_KEY = 'deepsage:deposit-cobo-manual-pick';

function normalizeChainKey(chain) {
  return String(chain ?? '')
    .trim()
    .toUpperCase();
}

function normalizeCurrencySymbol(currency) {
  return String(currency ?? '')
    .trim()
    .toUpperCase();
}

function isUsdcSymbol(sym) {
  return sym === 'USDC' || sym === 'USDC.E' || sym === 'USDCE';
}

function pickPreferredUsdcCurrencyIdx(currencies) {
  const list = Array.isArray(currencies) ? currencies : [];
  const usdcIdx = list.findIndex((row) => isUsdcSymbol(normalizeCurrencySymbol(row?.currency)));
  return usdcIdx >= 0 ? usdcIdx : 0;
}

/**
 * @returns {{ chain: string, currency: string } | null}
 */
export function readManualCoboPick() {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const chain = String(parsed?.chain ?? '').trim();
    const currency = String(parsed?.currency ?? '').trim();
    if (!chain) return null;
    return { chain, currency };
  } catch {
    return null;
  }
}

/** @param {{ chain?: string, currency?: string }} pick */
export function writeManualCoboPick(pick) {
  if (typeof sessionStorage === 'undefined') return;
  const chain = String(pick?.chain ?? '').trim();
  if (!chain) return;
  const currency = String(pick?.currency ?? '').trim();
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ chain, currency }));
  } catch {
    // ignore quota / private mode
  }
}

export function clearManualCoboPick() {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

registerAuthTeardown(clearManualCoboPick);

/**
 * @param {Array<{ chain?: string, currencies?: Array<{ currency?: string }> }>} options
 * @param {{ chain?: string, currency?: string }} pick
 * @returns {{ chainIdx: number, tokenIdx: number, currencies: Array } | null}
 */
export function resolveCoboPickFromOptions(options, pick) {
  const chainKey = normalizeChainKey(pick?.chain);
  if (!chainKey) return null;

  const list = Array.isArray(options) ? options : [];
  const chainIdx = list.findIndex((row) => normalizeChainKey(row?.chain) === chainKey);
  if (chainIdx < 0) return null;

  const currencies = list[chainIdx]?.currencies ?? [];
  const currencyKey = normalizeCurrencySymbol(pick?.currency);
  let tokenIdx = 0;
  if (currencyKey) {
    const found = currencies.findIndex(
      (row) => normalizeCurrencySymbol(row?.currency) === currencyKey
    );
    tokenIdx = found >= 0 ? found : pickPreferredUsdcCurrencyIdx(currencies);
  } else {
    tokenIdx = pickPreferredUsdcCurrencyIdx(currencies);
  }

  return { chainIdx, tokenIdx, currencies };
}
